

// Template Dashboard 2 MUI helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const dialogActions = {
  styleOverrides: {
    root: {
    },
  },
};

export default dialogActions;
